export const EMPLOYEE = "Employee";
export const CUSTOMER = "Customer";
